import { useEffect, useState } from "react";
import Users from "./Users";
import VerifyWithPassword from "./VerifyWithPassword";
import { Model, UseForm } from "../../../../hooks";

const SwitchUser = ({ setShowForm, showForm, setSnackbar }) => {
  const { LoginMdl } = Model();
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
  } = UseForm(LoginMdl);
  const [step, setStep] = useState(1);
  const handleClose = () => {
    setShowForm(false);
  };

  useEffect(() => {
    return () => {
      resetFormControls();
      setStep(1);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderComponent = () => {
    switch (step) {
      case 1:
        return <Users {...{ handleClose, setStep, setValues, setSnackbar }} />;
      case 2:
        return (
          <VerifyWithPassword
            {...{
              values,
              setValues,
              errors,
              setErrors,
              handleInpChg,
              handleClose,
              setStep,
              setSnackbar,
            }}
          />
        );
      default:
        break;
    }
  };

  return <>{renderComponent()}</>;
};

export default SwitchUser;
